// extracted by mini-css-extract-plugin
export const container = "breadcrumb-module--container--IDwcv";
export const back = "breadcrumb-module--back--3P1in";